module.exports = __webpack_public_path__ + "img/ios.372cda08.jpg";